'use client';

import React from 'react';
import styles from './Loader.module.scss';
import Row from '../Grid/Row/Row';
import Col from '../Grid/Col/Col';

export interface LoaderProps {
  size?: number;
  className?: string;
}

const Loader: React.FC<LoaderProps> = ({ size = 64, className }) => {
  return (
    <Row justify="center" className={className}>
      <Col xs={12}>
        <svg
          className={styles.loader}
          height={size}
          width={size}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 124 124"
          role="img"
          aria-label="Loading"
        >
          <g className={styles.spinner}>
            <circle className={styles.loaderCircle} cx="62" cy="62" r="60" />
            <defs>
              <linearGradient id="linear" x1="0%" y1="100%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="transparent" />
                <stop offset="30%" stopColor="#D7BE96" />
              </linearGradient>
            </defs>
            <path
              className={styles.loaderPath}
              stroke="url(#linear)"
              d="M62 2c25.3439 0 47.041 15.7181 56 38"
            />
          </g>
        </svg>
      </Col>
    </Row>
  );
};

Loader.displayName = 'Loader';

export default Loader;
